import React from 'react';
import {AdminBookingReportVO} from "../../../types/model/valueObject/booking/AdminBookingReportVO";
import {AdminBookingCardListItem} from "./AdminBookingCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";
import {ReportDialogSetterProps} from "../../../interfaces";

type AdminBookingCardListProps = {
  items?: AdminBookingReportVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
  onOpenDialog: (dialog: ReportDialogSetterProps<AdminBookingReportVO>) => void;
}

const AdminBookingCardList = ({
  items,
  expandByIndex,
  onToggleExpand,
  onOpenDialog
}: AdminBookingCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item, index) =>
        <AdminBookingCardListItem
          key={item?.id || index}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
          onOpenDialog={onOpenDialog}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const AdminBookingCardListWithLoader = withLoader(AdminBookingCardList, skeletonLoader);

export {
  AdminBookingCardList,
  AdminBookingCardListWithLoader
};
